module.exports = __webpack_public_path__ + "img/ev-charging-md.efe30670.png";